import i18n from 'i18next';

import { Tiltak, TiltakStatus, TiltakType } from '../../../../types/registration/tiltak';
import { TiltakNameMap } from '../../../../types/registration/tiltakNameMap';

import { TiltakFormData } from './form/types';

export function formDataToTiltak(formData: TiltakFormData) {
  const title = i18n.t(`tiltak.${formData.underkategori}`);

  const tiltak: Tiltak = {
    tiltaksKategori: formData.kategori,
    beskrivelseBokmal: formData.beskrivelse,
    beskrivelseNynorsk: formData.beskrivelse,
    navnBokmal: title,
    navnNynorsk: title,
    rehabilitering: false,
    status: TiltakStatus.Gjenstaende,
    tiltakId: formData.tiltakId
  };
  return tiltak;
}

export function fromTiltakToFormData(tiltak: Tiltak): TiltakFormData {
  const underkategori = getTiltakTypeFromStringValue(tiltak.navnBokmal ?? tiltak.navnNynorsk);

  if (!underkategori) {
    throw new Error('Could not determine tiltak underkategori from tiltak navn.');
  }

  return {
    tiltakId: tiltak?.tiltakId,
    kategori: tiltak.tiltaksKategori,
    underkategori,
    beskrivelse: tiltak.beskrivelseBokmal ?? tiltak.beskrivelseNynorsk ?? '',
    tittel: tiltak.navnBokmal ?? tiltak.navnNynorsk ?? ''
  };
}

// Converts string value from database to key value
const getTiltakTypeFromStringValue = (value?: string): TiltakType | undefined => {
  if (!value) {
    return undefined;
  }

  for (const key in TiltakNameMap) {
    const nestedRecord = TiltakNameMap[key as TiltakType];
    const matchingEntry = Object.entries(nestedRecord).find(
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      ([_, val]) => val === value
    );
    if (matchingEntry) {
      return key as TiltakType;
    }
  }
  return undefined;
};
